import React from "react";
import { Navigate } from "react-router-dom";
import { isAnyPermissionAllowed } from "../../utils/permissionHelper";
import { isAuthenticated } from "../../services/authService";

/**
 * Route guard: redirects unauthenticated users to /login and users without the
 * required permission(s) to /access-denied.
 *
 * @param {string|string[]} permKey  - permission key(s) required to view the page
 *                                     (array = any one of them is enough)
 * @param {React.ReactNode} children - the protected page element
 */
const PermissionRoute = ({ permKey, children }) => {
  if (!isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }
  if (permKey && !isAnyPermissionAllowed(permKey)) {
    return <Navigate to="/access-denied" replace />;
  }
  return children;
};

export default PermissionRoute;
